{
 "meta": {
  "live": true,
  "refreshed_at": "2026-10-09T02:00:00.000Z",
  "range": "28d",
  "prev_range": "28 ngày trước",
  "period": {
   "start": "2026-09-12",
   "end": "2026-10-09"
  },
  "prev_period": {
   "start": "2026-08-15",
   "end": "2026-09-11"
  },
  "sources": {
   "palexy": "verified",
   "fsales": "verified",
   "vpage": "verified",
   "captures": "partial"
  },
  "fixture": true
 },
 "thresholds": [
  {
   "metric": "contact",
   "label": "Tỷ lệ xin được SĐT (có SĐT / ghi nhận)",
   "green": 65,
   "amber": 50,
   "direction": "higher"
  },
  {
   "metric": "coverage",
   "label": "Độ phủ ghi nhận (ghi nhận / lượt khách)",
   "green": 25,
   "amber": 15,
   "direction": "higher"
  },
  {
   "metric": "cr_care",
   "label": "CR chăm sóc (đơn sau ≥ D+1 / lead có SĐT)",
   "green": 3,
   "amber": 1,
   "direction": "higher"
  },
  {
   "metric": "cr_instore",
   "label": "CR tại quầy (bán tại quầy / lượt khách)",
   "green": 8,
   "amber": 4,
   "direction": "higher"
  },
  {
   "metric": "interaction",
   "label": "Tỷ lệ tương tác Vpage (tương tác / có SĐT)",
   "green": 8,
   "amber": 3,
   "direction": "higher"
  },
  {
   "metric": "verify_gap",
   "label": "Khoảng cách tự báo − xác minh ((chốt tag − đơn xác minh) / chốt tag)",
   "green": 20,
   "amber": 40,
   "direction": "lower"
  }
 ],
 "system": {
  "visits": 7118,
  "captures": 1752,
  "with_phone": 1000,
  "interacted": 33,
  "closed_tag": 591,
  "orders_verified": 418,
  "orders_same_day": 395,
  "orders_followup": 23,
  "instore_sales": 466,
  "phone_matched_vpage": 66,
  "fsales_orders": 1919,
  "fsales_buyers": 1858,
  "fsales_revenue": 15849600000,
  "visits_missing_days": 10,
  "rates": {
   "coverage": 22.94,
   "contact": 57.08,
   "interaction": 3.3,
   "close_tag": 33.73,
   "cr_care": 2.3,
   "cr_instore": 6.11,
   "cr_store": 25.11,
   "verify_gap": 29.27
  },
  "delta": {
   "coverage": 1.74,
   "contact": -0.08,
   "interaction": 0.29,
   "close_tag": 0.05,
   "cr_care": 0.47,
   "cr_instore": 0.04,
   "cr_store": 0.1,
   "verify_gap": -1.02
  },
  "flags": [
   "visits_missing_days"
  ],
  "verify_gap_note": null
 },
 "stores": [
  {
   "store_code": "NCV",
   "store_name": "Gearvn Nguyễn Cửu Vân",
   "tier": "B",
   "rank": 1,
   "visits": 425,
   "captures": 500,
   "with_phone": 283,
   "interacted": 19,
   "closed_tag": 169,
   "orders_verified": 162,
   "orders_same_day": 150,
   "orders_followup": 12,
   "instore_sales": 51,
   "phone_matched_vpage": 50,
   "fsales_orders": 209,
   "fsales_buyers": 293,
   "fsales_revenue": 2511600000,
   "visits_missing_days": 2,
   "rates": {
    "coverage": 107.06,
    "contact": 56.6,
    "interaction": 6.71,
    "close_tag": 33.8,
    "cr_care": 4.24,
    "cr_instore": 10.82,
    "cr_store": 44.94,
    "verify_gap": 4.14
   },
   "delta": {
    "coverage": 6.63,
    "contact": -0.39,
    "interaction": 0.67,
    "close_tag": 0.04,
    "cr_care": 0.84,
    "cr_instore": -0.2,
    "cr_store": -0.2,
    "verify_gap": -0.32
   },
   "flags": [
    "coverage_over_100",
    "visits_missing_days"
   ],
   "verify_gap_note": null
  },
  {
   "store_code": "TBT",
   "store_name": "Gearvn Trần Bình Trọng",
   "tier": "B",
   "rank": 2,
   "visits": 864,
   "captures": 276,
   "with_phone": 151,
   "interacted": 1,
   "closed_tag": 127,
   "orders_verified": 77,
   "orders_same_day": 74,
   "orders_followup": 3,
   "instore_sales": 147,
   "phone_matched_vpage": 1,
   "fsales_orders": 235,
   "fsales_buyers": 214,
   "fsales_revenue": 1833000000,
   "visits_missing_days": 2,
   "rates": {
    "coverage": 29.63,
    "contact": 54.71,
    "interaction": null,
    "close_tag": 46.01,
    "cr_care": 1.99,
    "cr_instore": 16.2,
    "cr_store": 25.46,
    "verify_gap": 39.37
   },
   "delta": {
    "coverage": 2.04,
    "contact": 0.02,
    "interaction": null,
    "close_tag": -0.08,
    "cr_care": 0.56,
    "cr_instore": 0.36,
    "cr_store": 0.14,
    "verify_gap": -0.46
   },
   "flags": [
    "vpage_low_match",
    "visits_missing_days"
   ],
   "verify_gap_note": null
  },
  {
   "store_code": "KVC",
   "store_name": "Gearvn Kha Vạn Cân",
   "tier": "C",
   "rank": 3,
   "visits": 1193,
   "captures": 513,
   "with_phone": 250,
   "interacted": 13,
   "closed_tag": 155,
   "orders_verified": 113,
   "orders_same_day": 107,
   "orders_followup": 6,
   "instore_sales": 135,
   "phone_matched_vpage": 14,
   "fsales_orders": 280,
   "fsales_buyers": 254,
   "fsales_revenue": 2184000000,
   "visits_missing_days": 2,
   "rates": {
    "coverage": 40.57,
    "contact": 48.73,
    "interaction": null,
    "close_tag": 30.21,
    "cr_care": 2.4,
    "cr_instore": 10.39,
    "cr_store": 21.79,
    "verify_gap": 27.1
   },
   "delta": {
    "coverage": 3.1,
    "contact": 0.09,
    "interaction": null,
    "close_tag": 0.02,
    "cr_care": 0.24,
    "cr_instore": -0.21,
    "cr_store": -0.21,
    "verify_gap": 0.02
   },
   "flags": [
    "vpage_low_match",
    "visits_missing_days"
   ],
   "verify_gap_note": null
  },
  {
   "store_code": "HHT",
   "store_name": "Gearvn Hoàng Hoa Thám",
   "tier": "C",
   "rank": 4,
   "visits": 2910,
   "captures": 372,
   "with_phone": 270,
   "interacted": 0,
   "closed_tag": 131,
   "orders_verified": 52,
   "orders_same_day": 50,
   "orders_followup": 2,
   "instore_sales": 32,
   "phone_matched_vpage": 1,
   "fsales_orders": 625,
   "fsales_buyers": 575,
   "fsales_revenue": 4875000000,
   "visits_missing_days": 2,
   "rates": {
    "coverage": 12.06,
    "contact": 72.58,
    "interaction": null,
    "close_tag": 35.22,
    "cr_care": 0.74,
    "cr_instore": 1.07,
    "cr_store": 19.83,
    "verify_gap": 60.31
   },
   "delta": {
    "coverage": 1.15,
    "contact": -0.17,
    "interaction": null,
    "close_tag": 0.15,
    "cr_care": 0.34,
    "cr_instore": 0.06,
    "cr_store": 0.06,
    "verify_gap": -0.02
   },
   "flags": [
    "vpage_low_match",
    "visits_missing_days"
   ],
   "verify_gap_note": null
  },
  {
   "store_code": "TH",
   "store_name": "Gearvn Thái Hà",
   "tier": "C",
   "rank": 5,
   "visits": 1726,
   "captures": 91,
   "with_phone": 46,
   "interacted": 0,
   "closed_tag": 9,
   "orders_verified": 14,
   "orders_same_day": 14,
   "orders_followup": 0,
   "instore_sales": 101,
   "phone_matched_vpage": 0,
   "fsales_orders": 570,
   "fsales_buyers": 522,
   "fsales_revenue": 4446000000,
   "visits_missing_days": 2,
   "rates": {
    "coverage": 5.04,
    "contact": 50.55,
    "interaction": null,
    "close_tag": 9.89,
    "cr_care": 0,
    "cr_instore": 5.45,
    "cr_store": 31.23,
    "verify_gap": null
   },
   "delta": {
    "coverage": 0.49,
    "contact": 0.55,
    "interaction": null,
    "close_tag": 0.37,
    "cr_care": 0,
    "cr_instore": -0.02,
    "cr_store": 0.39,
    "verify_gap": null
   },
   "flags": [
    "verify_gap_over_tag",
    "vpage_low_match",
    "visits_missing_days"
   ],
   "verify_gap_note": "đơn xác minh vượt tag"
  }
 ],
 "benchmark": {
  "coverage": 29.63,
  "contact": 54.71,
  "interaction": 6.71,
  "close_tag": 33.8,
  "cr_care": 1.99,
  "cr_instore": 10.39,
  "cr_store": 25.46,
  "verify_gap": 33.24
 },
 "daily": [
  {
   "store_code": "NCV",
   "ngay": "2026-09-12",
   "visits": 21,
   "captures": 26,
   "with_phone": 13,
   "interacted": 2,
   "closed_tag": 6,
   "orders_verified": 6,
   "orders_same_day": 6,
   "orders_followup": 0,
   "instore_sales": 0,
   "phone_matched_vpage": 2,
   "fsales_orders": 9,
   "visits_known": true
  },
  {
   "store_code": "NCV",
   "ngay": "2026-09-13",
   "visits": 12,
   "captures": 13,
   "with_phone": 7,
   "interacted": 0,
   "closed_tag": 7,
   "orders_verified": 7,
   "orders_same_day": 6,
   "orders_followup": 1,
   "instore_sales": 1,
   "phone_matched_vpage": 1,
   "fsales_orders": 4,
   "visits_known": true
  },
  {
   "store_code": "NCV",
   "ngay": "2026-09-14",
   "visits": 20,
   "captures": 19,
   "with_phone": 13,
   "interacted": 0,
   "closed_tag": 6,
   "orders_verified": 6,
   "orders_same_day": 6,
   "orders_followup": 0,
   "instore_sales": 3,
   "phone_matched_vpage": 2,
   "fsales_orders": 10,
   "visits_known": true
  },
  {
   "store_code": "NCV",
   "ngay": "2026-09-15",
   "visits": 19,
   "captures": 20,
   "with_phone": 7,
   "interacted": 0,
   "closed_tag": 7,
   "orders_verified": 7,
   "orders_same_day": 6,
   "orders_followup": 1,
   "instore_sales": 2,
   "phone_matched_vpage": 2,
   "fsales_orders": 10,
   "visits_known": true
  },
  {
   "store_code": "NCV",
   "ngay": "2026-09-16",
   "visits": 21,
   "captures": 19,
   "with_phone": 13,
   "interacted": 0,
   "closed_tag": 6,
   "orders_verified": 6,
   "orders_same_day": 6,
   "orders_followup": 0,
   "instore_sales": 1,
   "phone_matched_vpage": 2,
   "fsales_orders": 11,
   "visits_known": true
  },
  {
   "store_code": "NCV",
   "ngay": "2026-09-17",
   "visits": 17,
   "captures": 20,
   "with_phone": 13,
   "interacted": 2,
   "closed_tag": 7,
   "orders_verified": 7,
   "orders_same_day": 6,
   "orders_followup": 1,
   "instore_sales": 2,
   "phone_matched_vpage": 2,
   "fsales_orders": 7,
   "visits_known": true
  },
  {
   "store_code": "NCV",
   "ngay": "2026-09-18",
   "visits": 13,
   "captures": 19,
   "with_phone": 13,
   "interacted": 0,
   "closed_tag": 6,
   "orders_verified": 6,
   "orders_same_day": 6,
   "orders_followup": 0,
   "instore_sales": 1,
   "phone_matched_vpage": 3,
   "fsales_orders": 5,
   "visits_known": true
  },
  {
   "store_code": "NCV",
   "ngay": "2026-09-19",
   "visits": 13,
   "captures": 13,
   "with_phone": 6,
   "interacted": 0,
   "closed_tag": 7,
   "orders_verified": 0,
   "orders_same_day": 0,
   "orders_followup": 0,
   "instore_sales": 0,
   "phone_matched_vpage": 1,
   "fsales_orders": 6,
   "visits_known": true
  },
  {
   "store_code": "NCV",
   "ngay": "2026-09-20",
   "visits": 16,
   "captures": 20,
   "with_phone": 13,
   "interacted": 2,
   "closed_tag": 6,
   "orders_verified": 7,
   "orders_same_day": 6,
   "orders_followup": 1,
   "instore_sales": 4,
   "phone_matched_vpage": 2,
   "fsales_orders": 8,
   "visits_known": true
  },
  {
   "store_code": "NCV",
   "ngay": "2026-09-21",
   "visits": 19,
   "captures": 26,
   "with_phone": 13,
   "interacted": 0,
   "closed_tag": 7,
   "orders_verified": 6,
   "orders_same_day": 6,
   "orders_followup": 0,
   "instore_sales": 2,
   "phone_matched_vpage": 2,
   "fsales_orders": 7,
   "visits_known": true
  },
  {
   "store_code": "NCV",
   "ngay": "2026-09-22",
   "visits": 12,
   "captures": 6,
   "with_phone": 7,
   "interacted": 0,
   "closed_tag": 0,
   "orders_verified": 0,
   "orders_same_day": 0,
   "orders_followup": 0,
   "instore_sales": 2,
   "phone_matched_vpage": 2,
   "fsales_orders": 7,
   "visits_known": true
  },
  {
   "store_code": "NCV",
   "ngay": "2026-09-23",
   "visits": 13,
   "captures": 13,
   "with_phone": 7,
   "interacted": 0,
   "closed_tag": 6,
   "orders_verified": 7,
   "orders_same_day": 6,
   "orders_followup": 1,
   "instore_sales": 1,
   "phone_matched_vpage": 1,
   "fsales_orders": 5,
   "visits_known": true
  },
  {
   "store_code": "NCV",
   "ngay": "2026-09-24",
   "visits": 12,
   "captures": 7,
   "with_phone": 7,
   "interacted": 0,
   "closed_tag": 0,
   "orders_verified": 0,
   "orders_same_day": 0,
   "orders_followup": 0,
   "instore_sales": 1,
   "phone_matched_vpage": 1,
   "fsales_orders": 5,
   "visits_known": true
  },
  {
   "store_code": "NCV",
   "ngay": "2026-09-25",
   "visits": 21,
   "captures": 26,
   "with_phone": 13,
   "interacted": 3,
   "closed_tag": 7,
   "orders_verified": 6,
   "orders_same_day": 6,
   "orders_followup": 0,
   "instore_sales": 4,
   "phone_matched_vpage": 3,
   "fsales_orders": 8,
   "visits_known": true
  },
  {
   "store_code": "NCV",
   "ngay": "2026-09-26",
   "visits": 20,
   "captures": 19,
   "with_phone": 13,
   "interacted": 0,
   "closed_tag": 6,
   "orders_verified": 7,
   "orders_same_day": 6,
   "orders_followup": 1,
   "instore_sales": 4,
   "phone_matched_vpage": 2,
   "fsales_orders": 7,
   "visits_known": true
  },
  {
   "store_code": "NCV",
   "ngay": "2026-09-27",
   "visits": 14,
   "captures": 13,
   "with_phone": 6,
   "interacted": 0,
   "closed_tag": 7,
   "orders_verified": 6,
   "orders_same_day": 6,
   "orders_followup": 0,
   "instore_sales": 1,
   "phone_matched_vpage": 1,
   "fsales_orders": 6,
   "visits_known": true
  },
  {
   "store_code": "NCV",
   "ngay": "2026-09-28",
   "visits": 16,
   "captures": 13,
   "with_phone": 7,
   "interacted": 0,
   "closed_tag": 6,
   "orders_verified": 7,
   "orders_same_day": 6,
   "orders_followup": 1,
   "instore_sales": 3,
   "phone_matched_vpage": 1,
   "fsales_orders": 7,
   "visits_known": true
  },
  {
   "store_code": "NCV",
   "ngay": "2026-09-29",
   "visits": 15,
   "captures": 20,
   "with_phone": 13,
   "interacted": 3,
   "closed_tag": 7,
   "orders_verified": 6,
   "orders_same_day": 6,
   "orders_followup": 0,
   "instore_sales": 2,
   "phone_matched_vpage": 3,
   "fsales_orders": 5,
   "visits_known": true
  },
  {
   "store_code": "NCV",
   "ngay": "2026-09-30",
   "visits": 14,
   "captures": 13,
   "with_phone": 7,
   "interacted": 0,
   "closed_tag": 6,
   "orders_verified": 7,
   "orders_same_day": 6,
   "orders_followup": 1,
   "instore_sales": 0,
   "phone_matched_vpage": 1,
   "fsales_orders": 5,
   "visits_known": true
  },
  {
   "store_code": "NCV",
   "ngay": "2026-10-01",
   "visits": 13,
   "captures": 13,
   "with_phone": 7,
   "interacted": 0,
   "closed_tag": 7,
   "orders_verified": 6,
   "orders_same_day": 6,
   "orders_followup": 0,
   "instore_sales": 1,
   "phone_matched_vpage": 1,
   "fsales_orders": 5,
   "visits_known": true
  },
  {
   "store_code": "NCV",
   "ngay": "2026-10-02",
   "visits": 13,
   "captures": 13,
   "with_phone": 7,
   "interacted": 0,
   "closed_tag": 6,
   "orders_verified": 7,
   "orders_same_day": 6,
   "orders_followup": 1,
   "instore_sales": 2,
   "phone_matched_vpage": 1,
   "fsales_orders": 7,
   "visits_known": true
  },
  {
   "store_code": "NCV",
   "ngay": "2026-10-03",
   "visits": 13,
   "captures": 13,
   "with_phone": 7,
   "interacted": 2,
   "closed_tag": 7,
   "orders_verified": 6,
   "orders_same_day": 6,
   "orders_followup": 0,
   "instore_sales": 0,
   "phone_matched_vpage": 2,
   "fsales_orders": 5,
   "visits_known": true
  },
  {
   "store_code": "NCV",
   "ngay": "2026-10-04",
   "visits": 21,
   "captures": 26,
   "with_phone": 13,
   "interacted": 0,
   "closed_tag": 6,
   "orders_verified": 7,
   "orders_same_day": 6,
   "orders_followup": 1,
   "instore_sales": 3,
   "phone_matched_vpage": 2,
   "fsales_orders": 10,
   "visits_known": true
  },
  {
   "store_code": "NCV",
   "ngay": "2026-10-05",
   "visits": 21,
   "captures": 19,
   "with_phone": 6,
   "interacted": 0,
   "closed_tag": 7,
   "orders_verified": 6,
   "orders_same_day": 6,
   "orders_followup": 0,
   "instore_sales": 3,
   "phone_matched_vpage": 1,
   "fsales_orders": 13,
   "visits_known": true
  },
  {
   "store_code": "NCV",
   "ngay": "2026-10-06",
   "visits": 21,
   "captures": 26,
   "with_phone": 13,
   "interacted": 0,
   "closed_tag": 6,
   "orders_verified": 7,
   "orders_same_day": 6,
   "orders_followup": 1,
   "instore_sales": 3,
   "phone_matched_vpage": 2,
   "fsales_orders": 12,
   "visits_known": true
  },
  {
   "store_code": "NCV",
   "ngay": "2026-10-07",
   "visits": 15,
   "captures": 20,
   "with_phone": 13,
   "interacted": 3,
   "closed_tag": 7,
   "orders_verified": 6,
   "orders_same_day": 6,
   "orders_followup": 0,
   "instore_sales": 0,
   "phone_matched_vpage": 3,
   "fsales_orders": 7,
   "visits_known": true
  },
  {
   "store_code": "NCV",
   "ngay": "2026-10-08",
   "visits": 0,
   "captures": 26,
   "with_phone": 13,
   "interacted": 0,
   "closed_tag": 6,
   "orders_verified": 7,
   "orders_same_day": 6,
   "orders_followup": 1,
   "instore_sales": 1,
   "phone_matched_vpage": 2,
   "fsales_orders": 9,
   "visits_known": false
  },
  {
   "store_code": "NCV",
   "ngay": "2026-10-09",
   "visits": 0,
   "captures": 19,
   "with_phone": 13,
   "interacted": 2,
   "closed_tag": 7,
   "orders_verified": 6,
   "orders_same_day": 6,
   "orders_followup": 0,
   "instore_sales": 4,
   "phone_matched_vpage": 2,
   "fsales_orders": 9,
   "visits_known": false
  },
  {
   "store_code": "HHT",
   "ngay": "2026-09-12",
   "visits": 96,
   "captures": 13,
   "with_phone": 8,
   "interacted": 0,
   "closed_tag": 3,
   "orders_verified": 1,
   "orders_same_day": 1,
   "orders_followup": 0,
   "instore_sales": 0,
   "phone_matched_vpage": 0,
   "fsales_orders": 24,
   "visits_known": true
  },
  {
   "store_code": "HHT",
   "ngay": "2026-09-13",
   "visits": 118,
   "captures": 11,
   "with_phone": 8,
   "interacted": 0,
   "closed_tag": 4,
   "orders_verified": 2,
   "orders_same_day": 2,
   "orders_followup": 0,
   "instore_sales": 3,
   "phone_matched_vpage": 0,
   "fsales_orders": 17,
   "visits_known": true
  },
  {
   "store_code": "HHT",
   "ngay": "2026-09-14",
   "visits": 95,
   "captures": 11,
   "with_phone": 8,
   "interacted": 0,
   "closed_tag": 3,
   "orders_verified": 1,
   "orders_same_day": 1,
   "orders_followup": 0,
   "instore_sales": 1,
   "phone_matched_vpage": 0,
   "fsales_orders": 15,
   "visits_known": true
  },
  {
   "store_code": "HHT",
   "ngay": "2026-09-15",
   "visits": 88,
   "captures": 8,
   "with_phone": 5,
   "interacted": 0,
   "closed_tag": 3,
   "orders_verified": 1,
   "orders_same_day": 1,
   "orders_followup": 0,
   "instore_sales": 2,
   "phone_matched_vpage": 0,
   "fsales_orders": 14,
   "visits_known": true
  },
  {
   "store_code": "HHT",
   "ngay": "2026-09-16",
   "visits": 107,
   "captures": 11,
   "with_phone": 9,
   "interacted": 0,
   "closed_tag": 3,
   "orders_verified": 1,
   "orders_same_day": 1,
   "orders_followup": 0,
   "instore_sales": 2,
   "phone_matched_vpage": 0,
   "fsales_orders": 16,
   "visits_known": true
  },
  {
   "store_code": "HHT",
   "ngay": "2026-09-17",
   "visits": 110,
   "captures": 13,
   "with_phone": 10,
   "interacted": 0,
   "closed_tag": 3,
   "orders_verified": 1,
   "orders_same_day": 1,
   "orders_followup": 0,
   "instore_sales": 2,
   "phone_matched_vpage": 0,
   "fsales_orders": 26,
   "visits_known": true
  },
  {
   "store_code": "HHT",
   "ngay": "2026-09-18",
   "visits": 137,
   "captures": 21,
   "with_phone": 16,
   "interacted": 0,
   "closed_tag": 8,
   "orders_verified": 3,
   "orders_same_day": 3,
   "orders_followup": 0,
   "instore_sales": 2,
   "phone_matched_vpage": 0,
   "fsales_orders": 29,
   "visits_known": true
  },
  {
   "store_code": "HHT",
   "ngay": "2026-09-19",
   "visits": 89,
   "captures": 14,
   "with_phone": 11,
   "interacted": 0,
   "closed_tag": 4,
   "orders_verified": 2,
   "orders_same_day": 2,
   "orders_followup": 0,
   "instore_sales": 1,
   "phone_matched_vpage": 0,
   "fsales_orders": 20,
   "visits_known": true
  },
  {
   "store_code": "HHT",
   "ngay": "2026-09-20",
   "visits": 126,
   "captures": 10,
   "with_phone": 7,
   "interacted": 0,
   "closed_tag": 4,
   "orders_verified": 1,
   "orders_same_day": 1,
   "orders_followup": 0,
   "instore_sales": 0,
   "phone_matched_vpage": 0,
   "fsales_orders": 25,
   "visits_known": true
  },
  {
   "store_code": "HHT",
   "ngay": "2026-09-21",
   "visits": 142,
   "captures": 18,
   "with_phone": 13,
   "interacted": 0,
   "closed_tag": 5,
   "orders_verified": 2,
   "orders_same_day": 2,
   "orders_followup": 0,
   "instore_sales": 2,
   "phone_matched_vpage": 0,
   "fsales_orders": 25,
   "visits_known": true
  },
  {
   "store_code": "HHT",
   "ngay": "2026-09-22",
   "visits": 139,
   "captures": 12,
   "with_phone": 7,
   "interacted": 0,
   "closed_tag": 5,
   "orders_verified": 1,
   "orders_same_day": 1,
   "orders_followup": 0,
   "instore_sales": 1,
   "phone_matched_vpage": 0,
   "fsales_orders": 26,
   "visits_known": true
  },
  {
   "store_code": "HHT",
   "ngay": "2026-09-23",
   "visits": 137,
   "captures": 18,
   "with_phone": 14,
   "interacted": 0,
   "closed_tag": 8,
   "orders_verified": 2,
   "orders_same_day": 2,
   "orders_followup": 0,
   "instore_sales": 0,
   "phone_matched_vpage": 0,
   "fsales_orders": 27,
   "visits_known": true
  },
  {
   "store_code": "HHT",
   "ngay": "2026-09-24",
   "visits": 100,
   "captures": 14,
   "with_phone": 10,
   "interacted": 0,
   "closed_tag": 6,
   "orders_verified": 3,
   "orders_same_day": 3,
   "orders_followup": 0,
   "instore_sales": 1,
   "phone_matched_vpage": 0,
   "fsales_orders": 22,
   "visits_known": true
  },
  {
   "store_code": "HHT",
   "ngay": "2026-09-25",
   "visits": 132,
   "captures": 14,
   "with_phone": 11,
   "interacted": 0,
   "closed_tag": 6,
   "orders_verified": 3,
   "orders_same_day": 3,
   "orders_followup": 0,
   "instore_sales": 1,
   "phone_matched_vpage": 0,
   "fsales_orders": 27,
   "visits_known": true
  },
  {
   "store_code": "HHT",
   "ngay": "2026-09-26",
   "visits": 104,
   "captures": 17,
   "with_phone": 10,
   "interacted": 0,
   "closed_tag": 6,
   "orders_verified": 2,
   "orders_same_day": 1,
   "orders_followup": 1,
   "instore_sales": 0,
   "phone_matched_vpage": 0,
   "fsales_orders": 20,
   "visits_known": true
  },
  {
   "store_code": "HHT",
   "ngay": "2026-09-27",
   "visits": 84,
   "captures": 6,
   "with_phone": 4,
   "interacted": 0,
   "closed_tag": 3,
   "orders_verified": 1,
   "orders_same_day": 1,
   "orders_followup": 0,
   "instore_sales": 0,
   "phone_matched_vpage": 0,
   "fsales_orders": 21,
   "visits_known": true
  },
  {
   "store_code": "HHT",
   "ngay": "2026-09-28",
   "visits": 132,
   "captures": 16,
   "with_phone": 13,
   "interacted": 0,
   "closed_tag": 5,
   "orders_verified": 2,
   "orders_same_day": 2,
   "orders_followup": 0,
   "instore_sales": 1,
   "phone_matched_vpage": 0,
   "fsales_orders": 32,
   "visits_known": true
  },
  {
   "store_code": "HHT",
   "ngay": "2026-09-29",
   "visits": 87,
   "captures": 14,
   "with_phone": 9,
   "interacted": 0,
   "closed_tag": 4,
   "orders_verified": 2,
   "orders_same_day": 2,
   "orders_followup": 0,
   "instore_sales": 1,
   "phone_matched_vpage": 0,
   "fsales_orders": 18,
   "visits_known": true
  },
  {
   "store_code": "HHT",
   "ngay": "2026-09-30",
   "visits": 130,
   "captures": 16,
   "with_phone": 13,
   "interacted": 0,
   "closed_tag": 6,
   "orders_verified": 2,
   "orders_same_day": 2,
   "orders_followup": 0,
   "instore_sales": 1,
   "phone_matched_vpage": 0,
   "fsales_orders": 24,
   "visits_known": true
  },
  {
   "store_code": "HHT",
   "ngay": "2026-10-01",
   "visits": 102,
   "captures": 15,
   "with_phone": 11,
   "interacted": 0,
   "closed_tag": 4,
   "orders_verified": 2,
   "orders_same_day": 2,
   "orders_followup": 0,
   "instore_sales": 1,
   "phone_matched_vpage": 0,
   "fsales_orders": 23,
   "visits_known": true
  },
  {
   "store_code": "HHT",
   "ngay": "2026-10-02",
   "visits": 110,
   "captures": 11,
   "with_phone": 7,
   "interacted": 0,
   "closed_tag": 4,
   "orders_verified": 2,
   "orders_same_day": 2,
   "orders_followup": 0,
   "instore_sales": 2,
   "phone_matched_vpage": 0,
   "fsales_orders": 21,
   "visits_known": true
  },
  {
   "store_code": "HHT",
   "ngay": "2026-10-03",
   "visits": 116,
   "captures": 14,
   "with_phone": 10,
   "interacted": 0,
   "closed_tag": 5,
   "orders_verified": 2,
   "orders_same_day": 2,
   "orders_followup": 0,
   "instore_sales": 1,
   "phone_matched_vpage": 0,
   "fsales_orders": 17,
   "visits_known": true
  },
  {
   "store_code": "HHT",
   "ngay": "2026-10-04",
   "visits": 108,
   "captures": 12,
   "with_phone": 10,
   "interacted": 0,
   "closed_tag": 3,
   "orders_verified": 1,
   "orders_same_day": 1,
   "orders_followup": 0,
   "instore_sales": 1,
   "phone_matched_vpage": 0,
   "fsales_orders": 28,
   "visits_known": true
  },
  {
   "store_code": "HHT",
   "ngay": "2026-10-05",
   "visits": 90,
   "captures": 9,
   "with_phone": 7,
   "interacted": 0,
   "closed_tag": 4,
   "orders_verified": 2,
   "orders_same_day": 2,
   "orders_followup": 0,
   "instore_sales": 1,
   "phone_matched_vpage": 0,
   "fsales_orders": 15,
   "visits_known": true
  },
  {
   "store_code": "HHT",
   "ngay": "2026-10-06",
   "visits": 126,
   "captures": 17,
   "with_phone": 11,
   "interacted": 0,
   "closed_tag": 8,
   "orders_verified": 3,
   "orders_same_day": 3,
   "orders_followup": 0,
   "instore_sales": 2,
   "phone_matched_vpage": 0,
   "fsales_orders": 22,
   "visits_known": true
  },
  {
   "store_code": "HHT",
   "ngay": "2026-10-07",
   "visits": 105,
   "captures": 16,
   "with_phone": 13,
   "interacted": 0,
   "closed_tag": 7,
   "orders_verified": 3,
   "orders_same_day": 3,
   "orders_followup": 0,
   "instore_sales": 2,
   "phone_matched_vpage": 1,
   "fsales_orders": 23,
   "visits_known": true
  },
  {
   "store_code": "HHT",
   "ngay": "2026-10-08",
   "visits": 0,
   "captures": 13,
   "with_phone": 10,
   "interacted": 0,
   "closed_tag": 5,
   "orders_verified": 3,
   "orders_same_day": 2,
   "orders_followup": 1,
   "instore_sales": 0,
   "phone_matched_vpage": 0,
   "fsales_orders": 28,
   "visits_known": false
  },
  {
   "store_code": "HHT",
   "ngay": "2026-10-09",
   "visits": 0,
   "captures": 8,
   "with_phone": 5,
   "interacted": 0,
   "closed_tag": 2,
   "orders_verified": 1,
   "orders_same_day": 1,
   "orders_followup": 0,
   "instore_sales": 1,
   "phone_matched_vpage": 0,
   "fsales_orders": 20,
   "visits_known": false
  },
  {
   "store_code": "KVC",
   "ngay": "2026-09-12",
   "visits": 50,
   "captures": 26,
   "with_phone": 12,
   "interacted": 0,
   "closed_tag": 7,
   "orders_verified": 6,
   "orders_same_day": 6,
   "orders_followup": 0,
   "instore_sales": 7,
   "phone_matched_vpage": 0,
   "fsales_orders": 8,
   "visits_known": true
  },
  {
   "store_code": "KVC",
   "ngay": "2026-09-13",
   "visits": 37,
   "captures": 20,
   "with_phone": 9,
   "interacted": 1,
   "closed_tag": 5,
   "orders_verified": 3,
   "orders_same_day": 3,
   "orders_followup": 0,
   "instore_sales": 3,
   "phone_matched_vpage": 1,
   "fsales_orders": 8,
   "visits_known": true
  },
  {
   "store_code": "KVC",
   "ngay": "2026-09-14",
   "visits": 39,
   "captures": 10,
   "with_phone": 5,
   "interacted": 0,
   "closed_tag": 4,
   "orders_verified": 2,
   "orders_same_day": 2,
   "orders_followup": 0,
   "instore_sales": 3,
   "phone_matched_vpage": 0,
   "fsales_orders": 6,
   "visits_known": true
  },
  {
   "store_code": "KVC",
   "ngay": "2026-09-15",
   "visits": 38,
   "captures": 17,
   "with_phone": 9,
   "interacted": 0,
   "closed_tag": 5,
   "orders_verified": 3,
   "orders_same_day": 3,
   "orders_followup": 0,
   "instore_sales": 5,
   "phone_matched_vpage": 0,
   "fsales_orders": 8,
   "visits_known": true
  },
  {
   "store_code": "KVC",
   "ngay": "2026-09-16",
   "visits": 42,
   "captures": 23,
   "with_phone": 10,
   "interacted": 1,
   "closed_tag": 9,
   "orders_verified": 7,
   "orders_same_day": 6,
   "orders_followup": 1,
   "instore_sales": 2,
   "phone_matched_vpage": 1,
   "fsales_orders": 10,
   "visits_known": true
  },
  {
   "store_code": "KVC",
   "ngay": "2026-09-17",
   "visits": 54,
   "captures": 20,
   "with_phone": 8,
   "interacted": 0,
   "closed_tag": 6,
   "orders_verified": 5,
   "orders_same_day": 5,
   "orders_followup": 0,
   "instore_sales": 2,
   "phone_matched_vpage": 0,
   "fsales_orders": 11,
   "visits_known": true
  },
  {
   "store_code": "KVC",
   "ngay": "2026-09-18",
   "visits": 44,
   "captures": 22,
   "with_phone": 11,
   "interacted": 1,
   "closed_tag": 7,
   "orders_verified": 5,
   "orders_same_day": 5,
   "orders_followup": 0,
   "instore_sales": 2,
   "phone_matched_vpage": 1,
   "fsales_orders": 8,
   "visits_known": true
  },
  {
   "store_code": "KVC",
   "ngay": "2026-09-19",
   "visits": 50,
   "captures": 14,
   "with_phone": 7,
   "interacted": 0,
   "closed_tag": 5,
   "orders_verified": 3,
   "orders_same_day": 2,
   "orders_followup": 1,
   "instore_sales": 2,
   "phone_matched_vpage": 0,
   "fsales_orders": 13,
   "visits_known": true
  },
  {
   "store_code": "KVC",
   "ngay": "2026-09-20",
   "visits": 51,
   "captures": 27,
   "with_phone": 13,
   "interacted": 1,
   "closed_tag": 10,
   "orders_verified": 5,
   "orders_same_day": 5,
   "orders_followup": 0,
   "instore_sales": 7,
   "phone_matched_vpage": 1,
   "fsales_orders": 11,
   "visits_known": true
  },
  {
   "store_code": "KVC",
   "ngay": "2026-09-21",
   "visits": 40,
   "captures": 12,
   "with_phone": 6,
   "interacted": 1,
   "closed_tag": 3,
   "orders_verified": 2,
   "orders_same_day": 2,
   "orders_followup": 0,
   "instore_sales": 3,
   "phone_matched_vpage": 1,
   "fsales_orders": 10,
   "visits_known": true
  },
  {
   "store_code": "KVC",
   "ngay": "2026-09-22",
   "visits": 54,
   "captures": 22,
   "with_phone": 12,
   "interacted": 0,
   "closed_tag": 8,
   "orders_verified": 7,
   "orders_same_day": 7,
   "orders_followup": 0,
   "instore_sales": 10,
   "phone_matched_vpage": 0,
   "fsales_orders": 9,
   "visits_known": true
  },
  {
   "store_code": "KVC",
   "ngay": "2026-09-23",
   "visits": 34,
   "captures": 19,
   "with_phone": 10,
   "interacted": 1,
   "closed_tag": 7,
   "orders_verified": 6,
   "orders_same_day": 5,
   "orders_followup": 1,
   "instore_sales": 3,
   "phone_matched_vpage": 1,
   "fsales_orders": 8,
   "visits_known": true
  },
  {
   "store_code": "KVC",
   "ngay": "2026-09-24",
   "visits": 55,
   "captures": 19,
   "with_phone": 11,
   "interacted": 0,
   "closed_tag": 6,
   "orders_verified": 4,
   "orders_same_day": 4,
   "orders_followup": 0,
   "instore_sales": 5,
   "phone_matched_vpage": 0,
   "fsales_orders": 15,
   "visits_known": true
  },
  {
   "store_code": "KVC",
   "ngay": "2026-09-25",
   "visits": 45,
   "captures": 12,
   "with_phone": 6,
   "interacted": 1,
   "closed_tag": 3,
   "orders_verified": 2,
   "orders_same_day": 2,
   "orders_followup": 0,
   "instore_sales": 1,
   "phone_matched_vpage": 1,
   "fsales_orders": 7,
   "visits_known": true
  },
  {
   "store_code": "KVC",
   "ngay": "2026-09-26",
   "visits": 55,
   "captures": 13,
   "with_phone": 6,
   "interacted": 0,
   "closed_tag": 4,
   "orders_verified": 2,
   "orders_same_day": 2,
   "orders_followup": 0,
   "instore_sales": 7,
   "phone_matched_vpage": 0,
   "fsales_orders": 15,
   "visits_known": true
  },
  {
   "store_code": "KVC",
   "ngay": "2026-09-27",
   "visits": 36,
   "captures": 20,
   "with_phone": 10,
   "interacted": 1,
   "closed_tag": 7,
   "orders_verified": 7,
   "orders_same_day": 6,
   "orders_followup": 1,
   "instore_sales": 1,
   "phone_matched_vpage": 1,
   "fsales_orders": 8,
   "visits_known": true
  },
  {
   "store_code": "KVC",
   "ngay": "2026-09-28",
   "visits": 42,
   "captures": 16,
   "with_phone": 6,
   "interacted": 0,
   "closed_tag": 5,
   "orders_verified": 5,
   "orders_same_day": 5,
   "orders_followup": 0,
   "instore_sales": 7,
   "phone_matched_vpage": 0,
   "fsales_orders": 7,
   "visits_known": true
  },
  {
   "store_code": "KVC",
   "ngay": "2026-09-29",
   "visits": 49,
   "captures": 25,
   "with_phone": 11,
   "interacted": 1,
   "closed_tag": 5,
   "orders_verified": 4,
   "orders_same_day": 4,
   "orders_followup": 0,
   "instore_sales": 9,
   "phone_matched_vpage": 1,
   "fsales_orders": 13,
   "visits_known": true
  },
  {
   "store_code": "KVC",
   "ngay": "2026-09-30",
   "visits": 33,
   "captures": 9,
   "with_phone": 5,
   "interacted": 0,
   "closed_tag": 2,
   "orders_verified": 2,
   "orders_same_day": 2,
   "orders_followup": 0,
   "instore_sales": 5,
   "phone_matched_vpage": 0,
   "fsales_orders": 6,
   "visits_known": true
  },
  {
   "store_code": "KVC",
   "ngay": "2026-10-01",
   "visits": 43,
   "captures": 16,
   "with_phone": 7,
   "interacted": 0,
   "closed_tag": 5,
   "orders_verified": 3,
   "orders_same_day": 3,
   "orders_followup": 0,
   "instore_sales": 1,
   "phone_matched_vpage": 0,
   "fsales_orders": 11,
   "visits_known": true
  },
  {
   "store_code": "KVC",
   "ngay": "2026-10-02",
   "visits": 40,
   "captures": 18,
   "with_phone": 9,
   "interacted": 1,
   "closed_tag": 4,
   "orders_verified": 3,
   "orders_same_day": 2,
   "orders_followup": 1,
   "instore_sales": 6,
   "phone_matched_vpage": 1,
   "fsales_orders": 8,
   "visits_known": true
  },
  {
   "store_code": "KVC",
   "ngay": "2026-10-03",
   "visits": 53,
   "captures": 28,
   "with_phone": 13,
   "interacted": 0,
   "closed_tag": 6,
   "orders_verified": 5,
   "orders_same_day": 5,
   "orders_followup": 0,
   "instore_sales": 9,
   "phone_matched_vpage": 0,
   "fsales_orders": 13,
   "visits_known": true
  },
  {
   "store_code": "KVC",
   "ngay": "2026-10-04",
   "visits": 55,
   "captures": 14,
   "with_phone": 6,
   "interacted": 0,
   "closed_tag": 3,
   "orders_verified": 2,
   "orders_same_day": 2,
   "orders_followup": 0,
   "instore_sales": 6,
   "phone_matched_vpage": 1,
   "fsales_orders": 13,
   "visits_known": true
  },
  {
   "store_code": "KVC",
   "ngay": "2026-10-05",
   "visits": 57,
   "captures": 27,
   "with_phone": 14,
   "interacted": 1,
   "closed_tag": 10,
   "orders_verified": 7,
   "orders_same_day": 6,
   "orders_followup": 1,
   "instore_sales": 6,
   "phone_matched_vpage": 1,
   "fsales_orders": 12,
   "visits_known": true
  },
  {
   "store_code": "KVC",
   "ngay": "2026-10-06",
   "visits": 45,
   "captures": 18,
   "with_phone": 9,
   "interacted": 0,
   "closed_tag": 4,
   "orders_verified": 2,
   "orders_same_day": 2,
   "orders_followup": 0,
   "instore_sales": 4,
   "phone_matched_vpage": 0,
   "fsales_orders": 8,
   "visits_known": true
  },
  {
   "store_code": "KVC",
   "ngay": "2026-10-07",
   "visits": 52,
   "captures": 17,
   "with_phone": 9,
   "interacted": 1,
   "closed_tag": 5,
   "orders_verified": 3,
   "orders_same_day": 3,
   "orders_followup": 0,
   "instore_sales": 8,
   "phone_matched_vpage": 1,
   "fsales_orders": 14,
   "visits_known": true
  },
  {
   "store_code": "KVC",
   "ngay": "2026-10-08",
   "visits": 0,
   "captures": 11,
   "with_phone": 6,
   "interacted": 0,
   "closed_tag": 3,
   "orders_verified": 2,
   "orders_same_day": 2,
   "orders_followup": 0,
   "instore_sales": 4,
   "phone_matched_vpage": 0,
   "fsales_orders": 10,
   "visits_known": false
  },
  {
   "store_code": "KVC",
   "ngay": "2026-10-09",
   "visits": 0,
   "captures": 18,
   "with_phone": 10,
   "interacted": 1,
   "closed_tag": 7,
   "orders_verified": 6,
   "orders_same_day": 6,
   "orders_followup": 0,
   "instore_sales": 7,
   "phone_matched_vpage": 1,
   "fsales_orders": 10,
   "visits_known": false
  },
  {
   "store_code": "TBT",
   "ngay": "2026-09-12",
   "visits": 39,
   "captures": 11,
   "with_phone": 6,
   "interacted": 0,
   "closed_tag": 4,
   "orders_verified": 2,
   "orders_same_day": 2,
   "orders_followup": 0,
   "instore_sales": 7,
   "phone_matched_vpage": 0,
   "fsales_orders": 9,
   "visits_known": true
  },
  {
   "store_code": "TBT",
   "ngay": "2026-09-13",
   "visits": 26,
   "captures": 5,
   "with_phone": 2,
   "interacted": 0,
   "closed_tag": 2,
   "orders_verified": 1,
   "orders_same_day": 1,
   "orders_followup": 0,
   "instore_sales": 5,
   "phone_matched_vpage": 0,
   "fsales_orders": 6,
   "visits_known": true
  },
  {
   "store_code": "TBT",
   "ngay": "2026-09-14",
   "visits": 35,
   "captures": 9,
   "with_phone": 6,
   "interacted": 0,
   "closed_tag": 5,
   "orders_verified": 3,
   "orders_same_day": 3,
   "orders_followup": 0,
   "instore_sales": 5,
   "phone_matched_vpage": 0,
   "fsales_orders": 8,
   "visits_known": true
  },
  {
   "store_code": "TBT",
   "ngay": "2026-09-15",
   "visits": 34,
   "captures": 6,
   "with_phone": 3,
   "interacted": 0,
   "closed_tag": 2,
   "orders_verified": 2,
   "orders_same_day": 2,
   "orders_followup": 0,
   "instore_sales": 8,
   "phone_matched_vpage": 0,
   "fsales_orders": 8,
   "visits_known": true
  },
  {
   "store_code": "TBT",
   "ngay": "2026-09-16",
   "visits": 35,
   "captures": 12,
   "with_phone": 6,
   "interacted": 0,
   "closed_tag": 4,
   "orders_verified": 2,
   "orders_same_day": 2,
   "orders_followup": 0,
   "instore_sales": 5,
   "phone_matched_vpage": 0,
   "fsales_orders": 9,
   "visits_known": true
  },
  {
   "store_code": "TBT",
   "ngay": "2026-09-17",
   "visits": 39,
   "captures": 11,
   "with_phone": 7,
   "interacted": 0,
   "closed_tag": 5,
   "orders_verified": 3,
   "orders_same_day": 3,
   "orders_followup": 0,
   "instore_sales": 10,
   "phone_matched_vpage": 0,
   "fsales_orders": 10,
   "visits_known": true
  },
  {
   "store_code": "TBT",
   "ngay": "2026-09-18",
   "visits": 30,
   "captures": 11,
   "with_phone": 6,
   "interacted": 0,
   "closed_tag": 6,
   "orders_verified": 4,
   "orders_same_day": 4,
   "orders_followup": 0,
   "instore_sales": 4,
   "phone_matched_vpage": 0,
   "fsales_orders": 6,
   "visits_known": true
  },
  {
   "store_code": "TBT",
   "ngay": "2026-09-19",
   "visits": 24,
   "captures": 6,
   "with_phone": 3,
   "interacted": 0,
   "closed_tag": 3,
   "orders_verified": 2,
   "orders_same_day": 2,
   "orders_followup": 0,
   "instore_sales": 4,
   "phone_matched_vpage": 0,
   "fsales_orders": 5,
   "visits_known": true
  },
  {
   "store_code": "TBT",
   "ngay": "2026-09-20",
   "visits": 25,
   "captures": 6,
   "with_phone": 4,
   "interacted": 0,
   "closed_tag": 2,
   "orders_verified": 1,
   "orders_same_day": 0,
   "orders_followup": 1,
   "instore_sales": 5,
   "phone_matched_vpage": 0,
   "fsales_orders": 8,
   "visits_known": true
  },
  {
   "store_code": "TBT",
   "ngay": "2026-09-21",
   "visits": 30,
   "captures": 5,
   "with_phone": 3,
   "interacted": 0,
   "closed_tag": 2,
   "orders_verified": 1,
   "orders_same_day": 1,
   "orders_followup": 0,
   "instore_sales": 1,
   "phone_matched_vpage": 0,
   "fsales_orders": 8,
   "visits_known": true
  },
  {
   "store_code": "TBT",
   "ngay": "2026-09-22",
   "visits": 24,
   "captures": 8,
   "with_phone": 4,
   "interacted": 0,
   "closed_tag": 4,
   "orders_verified": 2,
   "orders_same_day": 2,
   "orders_followup": 0,
   "instore_sales": 6,
   "phone_matched_vpage": 0,
   "fsales_orders": 5,
   "visits_known": true
  },
  {
   "store_code": "TBT",
   "ngay": "2026-09-23",
   "visits": 36,
   "captures": 11,
   "with_phone": 7,
   "interacted": 0,
   "closed_tag": 4,
   "orders_verified": 3,
   "orders_same_day": 3,
   "orders_followup": 0,
   "instore_sales": 3,
   "phone_matched_vpage": 0,
   "fsales_orders": 8,
   "visits_known": true
  },
  {
   "store_code": "TBT",
   "ngay": "2026-09-24",
   "visits": 27,
   "captures": 10,
   "with_phone": 6,
   "interacted": 0,
   "closed_tag": 5,
   "orders_verified": 2,
   "orders_same_day": 2,
   "orders_followup": 0,
   "instore_sales": 5,
   "phone_matched_vpage": 0,
   "fsales_orders": 6,
   "visits_known": true
  },
  {
   "store_code": "TBT",
   "ngay": "2026-09-25",
   "visits": 27,
   "captures": 9,
   "with_phone": 4,
   "interacted": 0,
   "closed_tag": 4,
   "orders_verified": 3,
   "orders_same_day": 3,
   "orders_followup": 0,
   "instore_sales": 7,
   "phone_matched_vpage": 0,
   "fsales_orders": 8,
   "visits_known": true
  },
  {
   "store_code": "TBT",
   "ngay": "2026-09-26",
   "visits": 34,
   "captures": 10,
   "with_phone": 5,
   "interacted": 0,
   "closed_tag": 6,
   "orders_verified": 4,
   "orders_same_day": 4,
   "orders_followup": 0,
   "instore_sales": 7,
   "phone_matched_vpage": 0,
   "fsales_orders": 11,
   "visits_known": true
  },
  {
   "store_code": "TBT",
   "ngay": "2026-09-27",
   "visits": 44,
   "captures": 14,
   "with_phone": 6,
   "interacted": 0,
   "closed_tag": 5,
   "orders_verified": 3,
   "orders_same_day": 3,
   "orders_followup": 0,
   "instore_sales": 10,
   "phone_matched_vpage": 0,
   "fsales_orders": 12,
   "visits_known": true
  },
  {
   "store_code": "TBT",
   "ngay": "2026-09-28",
   "visits": 40,
   "captures": 13,
   "with_phone": 8,
   "interacted": 0,
   "closed_tag": 7,
   "orders_verified": 4,
   "orders_same_day": 3,
   "orders_followup": 1,
   "instore_sales": 6,
   "phone_matched_vpage": 0,
   "fsales_orders": 11,
   "visits_known": true
  },
  {
   "store_code": "TBT",
   "ngay": "2026-09-29",
   "visits": 33,
   "captures": 9,
   "with_phone": 4,
   "interacted": 0,
   "closed_tag": 5,
   "orders_verified": 3,
   "orders_same_day": 3,
   "orders_followup": 0,
   "instore_sales": 2,
   "phone_matched_vpage": 0,
   "fsales_orders": 10,
   "visits_known": true
  },
  {
   "store_code": "TBT",
   "ngay": "2026-09-30",
   "visits": 25,
   "captures": 9,
   "with_phone": 5,
   "interacted": 0,
   "closed_tag": 5,
   "orders_verified": 4,
   "orders_same_day": 4,
   "orders_followup": 0,
   "instore_sales": 6,
   "phone_matched_vpage": 0,
   "fsales_orders": 6,
   "visits_known": true
  },
  {
   "store_code": "TBT",
   "ngay": "2026-10-01",
   "visits": 30,
   "captures": 9,
   "with_phone": 4,
   "interacted": 0,
   "closed_tag": 4,
   "orders_verified": 2,
   "orders_same_day": 2,
   "orders_followup": 0,
   "instore_sales": 4,
   "phone_matched_vpage": 0,
   "fsales_orders": 7,
   "visits_known": true
  },
  {
   "store_code": "TBT",
   "ngay": "2026-10-02",
   "visits": 42,
   "captures": 12,
   "with_phone": 8,
   "interacted": 0,
   "closed_tag": 6,
   "orders_verified": 3,
   "orders_same_day": 3,
   "orders_followup": 0,
   "instore_sales": 7,
   "phone_matched_vpage": 0,
   "fsales_orders": 12,
   "visits_known": true
  },
  {
   "store_code": "TBT",
   "ngay": "2026-10-03",
   "visits": 36,
   "captures": 12,
   "with_phone": 7,
   "interacted": 0,
   "closed_tag": 5,
   "orders_verified": 4,
   "orders_same_day": 4,
   "orders_followup": 0,
   "instore_sales": 0,
   "phone_matched_vpage": 0,
   "fsales_orders": 11,
   "visits_known": true
  },
  {
   "store_code": "TBT",
   "ngay": "2026-10-04",
   "visits": 29,
   "captures": 10,
   "with_phone": 5,
   "interacted": 0,
   "closed_tag": 4,
   "orders_verified": 3,
   "orders_same_day": 2,
   "orders_followup": 1,
   "instore_sales": 4,
   "phone_matched_vpage": 0,
   "fsales_orders": 7,
   "visits_known": true
  },
  {
   "store_code": "TBT",
   "ngay": "2026-10-05",
   "visits": 43,
   "captures": 16,
   "with_phone": 9,
   "interacted": 0,
   "closed_tag": 9,
   "orders_verified": 7,
   "orders_same_day": 7,
   "orders_followup": 0,
   "instore_sales": 7,
   "phone_matched_vpage": 0,
   "fsales_orders": 8,
   "visits_known": true
  },
  {
   "store_code": "TBT",
   "ngay": "2026-10-06",
   "visits": 41,
   "captures": 14,
   "with_phone": 7,
   "interacted": 0,
   "closed_tag": 7,
   "orders_verified": 3,
   "orders_same_day": 3,
   "orders_followup": 0,
   "instore_sales": 9,
   "phone_matched_vpage": 0,
   "fsales_orders": 12,
   "visits_known": true
  },
  {
   "store_code": "TBT",
   "ngay": "2026-10-07",
   "visits": 36,
   "captures": 8,
   "with_phone": 5,
   "interacted": 0,
   "closed_tag": 5,
   "orders_verified": 2,
   "orders_same_day": 2,
   "orders_followup": 0,
   "instore_sales": 3,
   "phone_matched_vpage": 0,
   "fsales_orders": 9,
   "visits_known": true
  },
  {
   "store_code": "TBT",
   "ngay": "2026-10-08",
   "visits": 0,
   "captures": 13,
   "with_phone": 7,
   "interacted": 1,
   "closed_tag": 4,
   "orders_verified": 2,
   "orders_same_day": 2,
   "orders_followup": 0,
   "instore_sales": 2,
   "phone_matched_vpage": 1,
   "fsales_orders": 9,
   "visits_known": false
  },
  {
   "store_code": "TBT",
   "ngay": "2026-10-09",
   "visits": 0,
   "captures": 7,
   "with_phone": 4,
   "interacted": 0,
   "closed_tag": 3,
   "orders_verified": 2,
   "orders_same_day": 2,
   "orders_followup": 0,
   "instore_sales": 5,
   "phone_matched_vpage": 0,
   "fsales_orders": 6,
   "visits_known": false
  },
  {
   "store_code": "TH",
   "ngay": "2026-09-12",
   "visits": 89,
   "captures": 4,
   "with_phone": 2,
   "interacted": 0,
   "closed_tag": 0,
   "orders_verified": 0,
   "orders_same_day": 0,
   "orders_followup": 0,
   "instore_sales": 1,
   "phone_matched_vpage": 0,
   "fsales_orders": 30,
   "visits_known": true
  },
  {
   "store_code": "TH",
   "ngay": "2026-09-13",
   "visits": 52,
   "captures": 2,
   "with_phone": 1,
   "interacted": 0,
   "closed_tag": 0,
   "orders_verified": 0,
   "orders_same_day": 0,
   "orders_followup": 0,
   "instore_sales": 7,
   "phone_matched_vpage": 0,
   "fsales_orders": 20,
   "visits_known": true
  },
  {
   "store_code": "TH",
   "ngay": "2026-09-14",
   "visits": 50,
   "captures": 3,
   "with_phone": 2,
   "interacted": 0,
   "closed_tag": 0,
   "orders_verified": 0,
   "orders_same_day": 0,
   "orders_followup": 0,
   "instore_sales": 0,
   "phone_matched_vpage": 0,
   "fsales_orders": 11,
   "visits_known": true
  },
  {
   "store_code": "TH",
   "ngay": "2026-09-15",
   "visits": 61,
   "captures": 4,
   "with_phone": 2,
   "interacted": 0,
   "closed_tag": 1,
   "orders_verified": 1,
   "orders_same_day": 1,
   "orders_followup": 0,
   "instore_sales": 3,
   "phone_matched_vpage": 0,
   "fsales_orders": 21,
   "visits_known": true
  },
  {
   "store_code": "TH",
   "ngay": "2026-09-16",
   "visits": 66,
   "captures": 4,
   "with_phone": 2,
   "interacted": 0,
   "closed_tag": 1,
   "orders_verified": 2,
   "orders_same_day": 2,
   "orders_followup": 0,
   "instore_sales": 2,
   "phone_matched_vpage": 0,
   "fsales_orders": 23,
   "visits_known": true
  },
  {
   "store_code": "TH",
   "ngay": "2026-09-17",
   "visits": 60,
   "captures": 2,
   "with_phone": 1,
   "interacted": 0,
   "closed_tag": 0,
   "orders_verified": 0,
   "orders_same_day": 0,
   "orders_followup": 0,
   "instore_sales": 7,
   "phone_matched_vpage": 0,
   "fsales_orders": 21,
   "visits_known": true
  },
  {
   "store_code": "TH",
   "ngay": "2026-09-18",
   "visits": 68,
   "captures": 5,
   "with_phone": 3,
   "interacted": 0,
   "closed_tag": 1,
   "orders_verified": 1,
   "orders_same_day": 1,
   "orders_followup": 0,
   "instore_sales": 6,
   "phone_matched_vpage": 0,
   "fsales_orders": 15,
   "visits_known": true
  },
  {
   "store_code": "TH",
   "ngay": "2026-09-19",
   "visits": 73,
   "captures": 4,
   "with_phone": 2,
   "interacted": 0,
   "closed_tag": 1,
   "orders_verified": 0,
   "orders_same_day": 0,
   "orders_followup": 0,
   "instore_sales": 4,
   "phone_matched_vpage": 0,
   "fsales_orders": 26,
   "visits_known": true
  },
  {
   "store_code": "TH",
   "ngay": "2026-09-20",
   "visits": 69,
   "captures": 4,
   "with_phone": 2,
   "interacted": 0,
   "closed_tag": 1,
   "orders_verified": 2,
   "orders_same_day": 2,
   "orders_followup": 0,
   "instore_sales": 4,
   "phone_matched_vpage": 0,
   "fsales_orders": 26,
   "visits_known": true
  },
  {
   "store_code": "TH",
   "ngay": "2026-09-21",
   "visits": 60,
   "captures": 2,
   "with_phone": 1,
   "interacted": 0,
   "closed_tag": 0,
   "orders_verified": 0,
   "orders_same_day": 0,
   "orders_followup": 0,
   "instore_sales": 0,
   "phone_matched_vpage": 0,
   "fsales_orders": 13,
   "visits_known": true
  },
  {
   "store_code": "TH",
   "ngay": "2026-09-22",
   "visits": 76,
   "captures": 4,
   "with_phone": 2,
   "interacted": 0,
   "closed_tag": 1,
   "orders_verified": 2,
   "orders_same_day": 2,
   "orders_followup": 0,
   "instore_sales": 0,
   "phone_matched_vpage": 0,
   "fsales_orders": 27,
   "visits_known": true
  },
  {
   "store_code": "TH",
   "ngay": "2026-09-23",
   "visits": 56,
   "captures": 2,
   "with_phone": 1,
   "interacted": 0,
   "closed_tag": 0,
   "orders_verified": 0,
   "orders_same_day": 0,
   "orders_followup": 0,
   "instore_sales": 2,
   "phone_matched_vpage": 0,
   "fsales_orders": 21,
   "visits_known": true
  },
  {
   "store_code": "TH",
   "ngay": "2026-09-24",
   "visits": 60,
   "captures": 4,
   "with_phone": 2,
   "interacted": 0,
   "closed_tag": 1,
   "orders_verified": 1,
   "orders_same_day": 1,
   "orders_followup": 0,
   "instore_sales": 0,
   "phone_matched_vpage": 0,
   "fsales_orders": 21,
   "visits_known": true
  },
  {
   "store_code": "TH",
   "ngay": "2026-09-25",
   "visits": 59,
   "captures": 2,
   "with_phone": 1,
   "interacted": 0,
   "closed_tag": 0,
   "orders_verified": 0,
   "orders_same_day": 0,
   "orders_followup": 0,
   "instore_sales": 5,
   "phone_matched_vpage": 0,
   "fsales_orders": 13,
   "visits_known": true
  },
  {
   "store_code": "TH",
   "ngay": "2026-09-26",
   "visits": 60,
   "captures": 2,
   "with_phone": 1,
   "interacted": 0,
   "closed_tag": 0,
   "orders_verified": 0,
   "orders_same_day": 0,
   "orders_followup": 0,
   "instore_sales": 8,
   "phone_matched_vpage": 0,
   "fsales_orders": 23,
   "visits_known": true
  },
  {
   "store_code": "TH",
   "ngay": "2026-09-27",
   "visits": 90,
   "captures": 5,
   "with_phone": 3,
   "interacted": 0,
   "closed_tag": 0,
   "orders_verified": 1,
   "orders_same_day": 1,
   "orders_followup": 0,
   "instore_sales": 3,
   "phone_matched_vpage": 0,
   "fsales_orders": 19,
   "visits_known": true
  },
  {
   "store_code": "TH",
   "ngay": "2026-09-28",
   "visits": 54,
   "captures": 2,
   "with_phone": 1,
   "interacted": 0,
   "closed_tag": 0,
   "orders_verified": 0,
   "orders_same_day": 0,
   "orders_followup": 0,
   "instore_sales": 5,
   "phone_matched_vpage": 0,
   "fsales_orders": 13,
   "visits_known": true
  },
  {
   "store_code": "TH",
   "ngay": "2026-09-29",
   "visits": 81,
   "captures": 5,
   "with_phone": 2,
   "interacted": 0,
   "closed_tag": 1,
   "orders_verified": 1,
   "orders_same_day": 1,
   "orders_followup": 0,
   "instore_sales": 0,
   "phone_matched_vpage": 0,
   "fsales_orders": 29,
   "visits_known": true
  },
  {
   "store_code": "TH",
   "ngay": "2026-09-30",
   "visits": 65,
   "captures": 3,
   "with_phone": 2,
   "interacted": 0,
   "closed_tag": 0,
   "orders_verified": 0,
   "orders_same_day": 0,
   "orders_followup": 0,
   "instore_sales": 9,
   "phone_matched_vpage": 0,
   "fsales_orders": 23,
   "visits_known": true
  },
  {
   "store_code": "TH",
   "ngay": "2026-10-01",
   "visits": 62,
   "captures": 3,
   "with_phone": 1,
   "interacted": 0,
   "closed_tag": 0,
   "orders_verified": 0,
   "orders_same_day": 0,
   "orders_followup": 0,
   "instore_sales": 3,
   "phone_matched_vpage": 0,
   "fsales_orders": 21,
   "visits_known": true
  },
  {
   "store_code": "TH",
   "ngay": "2026-10-02",
   "visits": 69,
   "captures": 2,
   "with_phone": 1,
   "interacted": 0,
   "closed_tag": 0,
   "orders_verified": 1,
   "orders_same_day": 1,
   "orders_followup": 0,
   "instore_sales": 1,
   "phone_matched_vpage": 0,
   "fsales_orders": 20,
   "visits_known": true
  },
  {
   "store_code": "TH",
   "ngay": "2026-10-03",
   "visits": 66,
   "captures": 4,
   "with_phone": 2,
   "interacted": 0,
   "closed_tag": 0,
   "orders_verified": 0,
   "orders_same_day": 0,
   "orders_followup": 0,
   "instore_sales": 6,
   "phone_matched_vpage": 0,
   "fsales_orders": 16,
   "visits_known": true
  },
  {
   "store_code": "TH",
   "ngay": "2026-10-04",
   "visits": 83,
   "captures": 4,
   "with_phone": 2,
   "interacted": 0,
   "closed_tag": 1,
   "orders_verified": 1,
   "orders_same_day": 1,
   "orders_followup": 0,
   "instore_sales": 4,
   "phone_matched_vpage": 0,
   "fsales_orders": 26,
   "visits_known": true
  },
  {
   "store_code": "TH",
   "ngay": "2026-10-05",
   "visits": 60,
   "captures": 3,
   "with_phone": 2,
   "interacted": 0,
   "closed_tag": 0,
   "orders_verified": 0,
   "orders_same_day": 0,
   "orders_followup": 0,
   "instore_sales": 3,
   "phone_matched_vpage": 0,
   "fsales_orders": 20,
   "visits_known": true
  },
  {
   "store_code": "TH",
   "ngay": "2026-10-06",
   "visits": 82,
   "captures": 5,
   "with_phone": 2,
   "interacted": 0,
   "closed_tag": 0,
   "orders_verified": 0,
   "orders_same_day": 0,
   "orders_followup": 0,
   "instore_sales": 10,
   "phone_matched_vpage": 0,
   "fsales_orders": 28,
   "visits_known": true
  },
  {
   "store_code": "TH",
   "ngay": "2026-10-07",
   "visits": 55,
   "captures": 3,
   "with_phone": 1,
   "interacted": 0,
   "closed_tag": 0,
   "orders_verified": 1,
   "orders_same_day": 1,
   "orders_followup": 0,
   "instore_sales": 1,
   "phone_matched_vpage": 0,
   "fsales_orders": 13,
   "visits_known": true
  },
  {
   "store_code": "TH",
   "ngay": "2026-10-08",
   "visits": 0,
   "captures": 2,
   "with_phone": 1,
   "interacted": 0,
   "closed_tag": 0,
   "orders_verified": 0,
   "orders_same_day": 0,
   "orders_followup": 0,
   "instore_sales": 1,
   "phone_matched_vpage": 0,
   "fsales_orders": 19,
   "visits_known": false
  },
  {
   "store_code": "TH",
   "ngay": "2026-10-09",
   "visits": 0,
   "captures": 2,
   "with_phone": 1,
   "interacted": 0,
   "closed_tag": 0,
   "orders_verified": 0,
   "orders_same_day": 0,
   "orders_followup": 0,
   "instore_sales": 6,
   "phone_matched_vpage": 0,
   "fsales_orders": 12,
   "visits_known": false
  }
 ],
 "staff": [
  {
   "staff_id": "sf08",
   "staff_name": "Bùi Đức Thịnh",
   "store_code": "KVC",
   "captures": 247,
   "with_phone": 120,
   "interacted": 7,
   "phone_matched_vpage": 7,
   "closed_tag": 75,
   "orders_verified": 54,
   "orders_same_day": 51,
   "orders_followup": 3,
   "instore_sales": 65,
   "rates": {
    "contact": 48.58,
    "interaction": null,
    "close_tag": 30.36,
    "cr_care": 2.5
   }
  },
  {
   "staff_id": "sf03",
   "staff_name": "Trần Quốc Bảo",
   "store_code": "KVC",
   "captures": 223,
   "with_phone": 109,
   "interacted": 6,
   "phone_matched_vpage": 6,
   "closed_tag": 67,
   "orders_verified": 49,
   "orders_same_day": 46,
   "orders_followup": 3,
   "instore_sales": 59,
   "rates": {
    "contact": 48.88,
    "interaction": null,
    "close_tag": 30.04,
    "cr_care": 2.75
   }
  },
  {
   "staff_id": "sf07",
   "staff_name": "Đỗ Anh Khoa",
   "store_code": "HHT",
   "captures": 195,
   "with_phone": 142,
   "interacted": 1,
   "phone_matched_vpage": 1,
   "closed_tag": 69,
   "orders_verified": 27,
   "orders_same_day": 26,
   "orders_followup": 1,
   "instore_sales": 17,
   "rates": {
    "contact": 72.82,
    "interaction": null,
    "close_tag": 35.38,
    "cr_care": 0.7
   }
  },
  {
   "staff_id": "sf09",
   "staff_name": "Ngô Tuấn Kiệt",
   "store_code": "TBT",
   "captures": 145,
   "with_phone": 79,
   "interacted": 1,
   "phone_matched_vpage": 1,
   "closed_tag": 67,
   "orders_verified": 40,
   "orders_same_day": 38,
   "orders_followup": 2,
   "instore_sales": 77,
   "rates": {
    "contact": 54.48,
    "interaction": null,
    "close_tag": 46.21,
    "cr_care": 2.53
   }
  },
  {
   "staff_id": "sf12",
   "staff_name": "Mai Thành Đạt",
   "store_code": "HHT",
   "captures": 103,
   "with_phone": 75,
   "interacted": 0,
   "phone_matched_vpage": 0,
   "closed_tag": 36,
   "orders_verified": 14,
   "orders_same_day": 13,
   "orders_followup": 1,
   "instore_sales": 9,
   "rates": {
    "contact": 72.82,
    "interaction": null,
    "close_tag": 34.95,
    "cr_care": 1.33
   }
  },
  {
   "staff_id": "sf02",
   "staff_name": "Nguyễn Minh Tâm",
   "store_code": "HHT",
   "captures": 98,
   "with_phone": 71,
   "interacted": 0,
   "phone_matched_vpage": 0,
   "closed_tag": 35,
   "orders_verified": 14,
   "orders_same_day": 13,
   "orders_followup": 1,
   "instore_sales": 8,
   "rates": {
    "contact": 72.45,
    "interaction": null,
    "close_tag": 35.71,
    "cr_care": 1.41
   }
  },
  {
   "staff_id": "sf04",
   "staff_name": "Lê Hoàng Phúc",
   "store_code": "TBT",
   "captures": 97,
   "with_phone": 53,
   "interacted": 0,
   "phone_matched_vpage": 0,
   "closed_tag": 45,
   "orders_verified": 27,
   "orders_same_day": 26,
   "orders_followup": 1,
   "instore_sales": 52,
   "rates": {
    "contact": 54.64,
    "interaction": null,
    "close_tag": 46.39,
    "cr_care": 1.89
   }
  },
  {
   "staff_id": "sf01",
   "staff_name": "Hà Khánh Duy",
   "store_code": "NCV",
   "captures": 260,
   "with_phone": 143,
   "interacted": 26,
   "phone_matched_vpage": 26,
   "closed_tag": 85,
   "orders_verified": 85,
   "orders_same_day": 78,
   "orders_followup": 7,
   "instore_sales": 26,
   "rates": {
    "contact": 55,
    "interaction": 18.18,
    "close_tag": 32.69,
    "cr_care": 4.9
   }
  },
  {
   "staff_id": "sf10",
   "staff_name": "Huỳnh Nhật Nam",
   "store_code": "TH",
   "captures": 26,
   "with_phone": 13,
   "interacted": 0,
   "phone_matched_vpage": 0,
   "closed_tag": 3,
   "orders_verified": 3,
   "orders_same_day": 3,
   "orders_followup": 0,
   "instore_sales": 28,
   "rates": {
    "contact": 50,
    "interaction": null,
    "close_tag": 11.54,
    "cr_care": 0
   }
  },
  {
   "staff_id": "sf05",
   "staff_name": "Phạm Gia Huy",
   "store_code": "TH",
   "captures": 25,
   "with_phone": 12,
   "interacted": 0,
   "phone_matched_vpage": 0,
   "closed_tag": 2,
   "orders_verified": 2,
   "orders_same_day": 2,
   "orders_followup": 0,
   "instore_sales": 27,
   "rates": {
    "contact": 48,
    "interaction": null,
    "close_tag": 8,
    "cr_care": 0
   }
  },
  {
   "staff_id": "sf06",
   "staff_name": "Võ Thanh Sơn",
   "store_code": "NCV",
   "captures": 137,
   "with_phone": 78,
   "interacted": 13,
   "phone_matched_vpage": 14,
   "closed_tag": 46,
   "orders_verified": 46,
   "orders_same_day": 42,
   "orders_followup": 4,
   "instore_sales": 14,
   "rates": {
    "contact": 56.93,
    "interaction": null,
    "close_tag": 33.58,
    "cr_care": 5.13
   }
  },
  {
   "staff_id": "sf11",
   "staff_name": "Đặng Quang Vinh",
   "store_code": "NCV",
   "captures": 137,
   "with_phone": 78,
   "interacted": 13,
   "phone_matched_vpage": 14,
   "closed_tag": 46,
   "orders_verified": 46,
   "orders_same_day": 42,
   "orders_followup": 4,
   "instore_sales": 14,
   "rates": {
    "contact": 56.93,
    "interaction": null,
    "close_tag": 33.58,
    "cr_care": 5.13
   }
  }
 ]
}
